import { render, staticRenderFns } from "./Evaluate.vue?vue&type=template&id=85d5fc2a&"
import script from "./Evaluate.vue?vue&type=script&lang=js&"
export * from "./Evaluate.vue?vue&type=script&lang=js&"
import style0 from "./Evaluate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports